import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import PublicationDetail from './pages/PublicationDetail'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/publications/:slug" element={<PublicationDetail />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App